import React, { useState } from "react";
import { Modal, Button, Select } from "antd";
import axios from "axios";
import "antd/dist/antd.css";

const { Option } = Select;

export const AddTeamModal = ({ version_id, clients, token, onUpdate }) => {
  const [visible, setVisible] = useState(false);

  const [selectedClient, setSelectedClient] = useState(null);

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    axios
      .post(
        process.env.REACT_APP_API + "/api/mobile_app/addteam",
        { version_id, team_id: selectedClient },
        {
          headers: {
            Authorization: token
          }
        }
      )
      .then(response => {
        console.log(response);
        onUpdate();
      })
      .catch(error => console.error(error));
    
    setVisible(false);
   
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleChange = value => {
    setSelectedClient(value);
  };

  return (
    <div>
      <Button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={showModal}>
        Ajouter un client
      </Button>
      <Modal title="Ajouter un client" visible={visible} onOk={handleOk} onCancel={handleCancel}>
        <Select
          showSearch
          allowClear={true}
          style={{ width: "90%" }}
          placeholder="Choisir le client à ajouter à la version mobile"
          optionFilterProp="children"
          onChange={handleChange}
        >
          {clients.map(client => (
            <Option key={client.id} value={client.id}>
              {client.label}
            </Option>
          ))}
        </Select>
      </Modal>
    </div>
  );
};



// WEBPACK FOOTER //
// src/pages/mobileAppVersions/AddTeam.modal.js